<template>
  <div class="service-page">
    <!-- 服务介绍部分 -->
    <section
      class="service-intro"
      style="padding-bottom: 0px"
      data-aos="fade-up"
    >
      <div class="container">
        <h2 class="section-title">我们的服务</h2>
        <p class="section-desc">为您提供专业、可靠的一站式解决方案</p>

        <div class="service-list">
          <el-row :gutter="30">
            <el-col
              :sm="12"
              :md="6"
              v-for="(item, index) in services"
              :key="index"
            >
              <div
                class="service-item"
                @mouseenter="hoverIndex = index"
                @mouseleave="hoverIndex = -1"
              >
                <div
                  class="service-icon"
                  :style="{ color: hoverIndex === index ? '#f97d01' : '#333' }"
                >
                  <i :class="item.icon"></i>
                </div>
                <h3 class="service-title">{{ item.title }}</h3>
                <p class="service-desc">{{ item.desc }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
    <!-- 视频 -->
    <!-- <div style="display: flex; align-items: center; margin-bottom: 20px">
      <video
        src="https://upload.shanxinyy.com/homepage/xxdSp.mp4"
        style="width: 60vw; height: 40vw; margin: 0 auto"
        controls
      ></video>
    </div> -->

    <video-with-cover
      video-src="https://upload.shanxinyy.com/homepage/xxdSp.mp4"
      video-cover="https://upload.shanxinyy.com/homepage/xxd2.jpg"
    />

    <!-- 服务详情部分 -->
    <section
      class="service-detail"
      v-for="(detail, index) in serviceDetails"
      :key="'detail' + index"
      :data-aos="index % 2 === 0 ? 'fade-right' : 'fade-left'"
    >
      <div class="container">
        <el-row :gutter="60" :class="{ 'flex-row-reverse': index % 2 !== 0 }">
          <el-col :sm="24" :md="12">
            <div class="detail-content">
              <h3 class="detail-title">{{ detail.title }}</h3>
              <p class="detail-desc">{{ detail.desc }}</p>
              <ul class="feature-list">
                <li v-for="(feature, fIndex) in detail.features" :key="fIndex">
                  <i class="el-icon-check"></i>
                  {{ feature }}
                </li>
              </ul>
              <!-- <el-button type="primary" class="detail-btn">了解更多</el-button> -->
            </div>
          </el-col>
          <el-col :sm="24" :md="12">
            <div class="detail-image">
              <!-- 图片位置预留 -->
              <img
                :src="detail.image"
                :alt="detail.title"
                v-if="detail.image"
              />
              <div class="image-placeholder" v-else>
                <i class="el-icon-picture"></i>
                <span>图片位置</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 服务优势部分 -->
    <section class="service-advantage" data-aos="fade-up">
      <div class="container">
        <h2 class="section-title">我们的优势</h2>
        <p class="section-desc">为什么选择我们</p>

        <div class="advantage-list">
          <el-row :gutter="30">
            <el-col
              :sm="12"
              :md="6"
              v-for="(item, index) in advantages"
              :key="index"
            >
              <div
                class="advantage-item"
                data-aos="zoom-in"
                :data-aos-delay="index * 100"
              >
                <div class="advantage-icon">
                  <i :class="item.icon"></i>
                </div>
                <h3 class="advantage-title">{{ item.title }}</h3>
                <p class="advantage-desc">{{ item.desc }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>

    <!-- 客户案例部分 -->
    <section class="service-case" data-aos="fade-up" v-if="false">
      <div class="container">
        <h2 class="section-title">成功案例</h2>
        <p class="section-desc">我们服务的部分客户</p>

        <div class="case-list">
          <el-carousel :interval="5000" arrow="always" height="400px">
            <el-carousel-item v-for="(item, index) in cases" :key="index">
              <div class="case-item">
                <div class="case-image">
                  <!-- 图片位置预留 -->
                  <img :src="item.image" :alt="item.title" v-if="item.image" />
                  <div class="image-placeholder" v-else>
                    <i class="el-icon-picture"></i>
                    <span>案例图片位置</span>
                  </div>
                </div>
                <div class="case-content">
                  <h3 class="case-title">{{ item.title }}</h3>
                  <p class="case-desc">{{ item.desc }}</p>
                  <div class="case-info">
                    <p><strong>行业：</strong>{{ item.industry }}</p>
                    <p><strong>解决方案：</strong>{{ item.solution }}</p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import "aos/dist/aos.css";
import AOS from "aos";
import VideoWithCover from "@/components/VideoWithCover.vue";
export default {
  components: {
    VideoWithCover,
  },
  name: "ServicePage",
  data() {
    return {
      hoverIndex: -1,
      services: [
        {
          icon: "el-icon-cloudy",
          title: "健康营养膳食",
          desc: `科学配餐\n理念营养均衡`,
        },
        {
          icon: "el-icon-cpu",
          title: "健康体检",
          desc: "采用医疗级健康检测一体机，检测多项数据，手机随时查看电子报告",
        },
        {
          icon: "el-icon-connection",
          title: "古方泡脚",
          desc: "采用传统中药足浴疗法提升老年人健康水平",
        },
        {
          icon: "el-icon-lock",
          title: "娱乐设施",
          desc: "配备麻将房等文娱设施",
        },
      ],
      serviceDetails: [
        {
          title: "健康营养膳食",
          desc: "我们深知“食养是医养之本”。我们秉持“营养为基、健康为本、个性为要”的理念，由专业营养师团队与医疗顾问共同打造科学膳食体系，为每一位长者及社区居民提供安全、均衡、适口的健康餐饮服务。",
          features: [
            "科学配餐精准搭配优质蛋白、膳食纤维及微量元素，助力慢病管理",
            "医养结合：针对糖尿病、高血压等常见健康问题，提供个性化饮食方案，与健康档案联动管理。",
            "时令鲜制：严选当季新鲜食材，少油少盐烹饪，保留食材本味与营养，拒绝预制菜。",
            "暖心服务：尊重个人饮食习惯，提供定制化餐食选择，让每一餐都温暖舒心。",
          ],
          image: "https://upload.shanxinyy.com/homepage/xxd2.jpg",
        },
        {
          title: "健康体检",
          desc: "善信医养社区服务中心始终以您的健康需求为核心，为您提供专业、便捷、全面的健康检测服务。通过科学化的健康评估与动态监测，帮助您及时了解身体状况，为个性化健康管理提供精准依据。",
          features: [
            "专业检测设备：配备医疗级健康检测一体机",
            "全程健康档案：建立电子健康档案，动态追踪数据变化，助力长期健康管理。",
            "个性化报告解读：由医护团队一对一分析数据，提供健康改善建议及慢病防控指导。",
            "便民惠民服务：社区定期开展免费检测活动，关爱老年群体及慢性病患者。",
          ],
          image: "https://upload.shanxinyy.com/homepage/ytj.jpg",
        },
      ],
      advantages: [
        {
          icon: "el-icon-medal",
          title: "专业团队",
          desc: "拥有10年以上行业经验的技术团队",
        },
        {
          icon: "el-icon-time",
          title: "快速响应",
          desc: "7×24小时技术支持，快速解决问题",
        },
        {
          icon: "el-icon-circle-plus-outline",
          title: "安全保障",
          desc: "多层安全防护，确保数据安全",
        },
        {
          icon: "el-icon-coin",
          title: "成本优化",
          desc: "优化资源配置，降低运营成本",
        },
      ],
      cases: [
        {
          title: "某大型电商平台",
          desc: "通过我们的云计算解决方案，客户成功应对了双11期间流量激增的挑战，系统稳定性达到99.99%。",
          industry: "电子商务",
          solution: "弹性云计算+CDN加速",
          image: "",
        },
        {
          title: "某金融机构",
          desc: "我们为其提供了私有云解决方案，满足了金融行业对数据安全和合规性的严格要求。",
          industry: "金融",
          solution: "私有云部署+安全加固",
          image: "",
        },
      ],
    };
  },
  mounted() {
    // 初始化AOS动画
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
  },
};
</script>

<style lang="scss" scoped>
/* 主题色 */
$primary-color: #f97d01;

.service-page {
  box-sizing: border-box;
  padding: 60px;

  .section-title {
    font-size: 32px;
    color: #333;
    text-align: center;
    margin-bottom: 15px;
    font-weight: 600;
  }

  .section-desc {
    font-size: 16px;
    color: #666;
    text-align: center;
    margin-bottom: 50px;
  }
}

/* 服务介绍样式 */
.service-intro {
  padding: 60px 0;

  .service-list {
    margin-top: 40px;
  }

  .service-item {
    text-align: center;
    padding: 30px 20px;
    margin-bottom: 30px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
    }
  }

  .service-icon {
    font-size: 48px;
    margin-bottom: 20px;
    transition: all 0.3s ease;
  }

  .service-title {
    font-size: 20px;
    color: #333;
    margin-bottom: 15px;
    font-weight: 600;
  }

  .service-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
  }
}

/* 服务详情样式 */
.service-detail {
  padding: 80px 0;
  background: #f9f9f9;

  &:nth-child(2n) {
    background: #fff;
  }

  .flex-row-reverse {
    flex-direction: row-reverse;
  }

  .detail-content {
    padding: 30px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .detail-title {
    font-size: 28px;
    color: #333;
    margin-bottom: 20px;
    font-weight: 600;
  }

  .detail-desc {
    font-size: 16px;
    color: #666;
    line-height: 1.8;
    margin-bottom: 25px;
  }

  .feature-list {
    margin-bottom: 30px;

    li {
      font-size: 15px;
      color: #555;
      margin-bottom: 12px;
      display: flex;
      align-items: center;

      i {
        color: $primary-color;
        margin-right: 10px;
        font-weight: bold;
      }
    }
  }

  .detail-btn {
    background: $primary-color;
    border-color: $primary-color;
    padding: 12px 30px;
    font-size: 16px;
    align-self: flex-start;

    &:hover {
      background: darken($primary-color, 10%);
      border-color: darken($primary-color, 10%);
    }
  }

  .detail-image {
    height: 100%;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image-placeholder {
      height: 350px;
      background: #eee;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #999;

      i {
        font-size: 60px;
        margin-bottom: 15px;
      }
    }
  }
}

/* 服务优势样式 */
.service-advantage {
  padding: 80px 0;
  background: #fff;

  .advantage-list {
    margin-top: 40px;
  }

  .advantage-item {
    text-align: center;
    padding: 40px 25px;
    margin-bottom: 30px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);

      .advantage-icon {
        background: $primary-color;
        color: #fff;
      }
    }
  }

  .advantage-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 25px;
    background: rgba($primary-color, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    color: $primary-color;
    transition: all 0.3s ease;
  }

  .advantage-title {
    font-size: 20px;
    color: #333;
    margin-bottom: 15px;
    font-weight: 600;
  }

  .advantage-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
  }
}

/* 客户案例样式 */
.service-case {
  padding: 80px 0;
  background: #f9f9f9;

  .case-list {
    margin-top: 40px;
  }

  .case-item {
    display: flex;
    height: 100%;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  }

  .case-image {
    width: 50%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image-placeholder {
      height: 100%;
      background: #eee;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #999;

      i {
        font-size: 60px;
        margin-bottom: 15px;
      }
    }
  }

  .case-content {
    width: 50%;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .case-title {
    font-size: 24px;
    color: #333;
    margin-bottom: 15px;
    font-weight: 600;
  }

  .case-desc {
    font-size: 15px;
    color: #666;
    line-height: 1.8;
    margin-bottom: 20px;
  }

  .case-info {
    p {
      font-size: 14px;
      color: #555;
      margin-bottom: 10px;

      strong {
        color: #333;
      }
    }
  }

  //   /deep/ .el-carousel__arrow {
  //     background: rgba($primary-color, 0.8);

  //     &:hover {
  //       background: $primary-color;
  //     }
  //   }

  //   /deep/ .el-carousel__indicators {
  //     .el-carousel__indicator {
  //       .el-carousel__button {
  //         background: rgba($primary-color, 0.4);
  //       }

  //       &.is-active {
  //         .el-carousel__button {
  //           background: $primary-color;
  //         }
  //       }
  //     }
  //   }
}

/* 响应式调整 */
@media (max-width: 992px) {
  .service-detail {
    .detail-image {
      margin-top: 30px;
    }
  }

  .case-item {
    flex-direction: column;

    .case-image,
    .case-content {
      width: 100%;
    }

    .case-image {
      height: 250px;
    }
  }
}

@media (max-width: 768px) {
  .service-page {
    padding: 30px 0;
  }

  .section-title {
    font-size: 26px !important;
  }

  .service-intro,
  .service-detail,
  .service-advantage,
  .service-case {
    padding: 40px 0;
  }
}
</style>
